const ClockIcon = ({ color = 'currentColor', height = '24px', width = '24px' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={width} height={height} color={color} fill={'none'}>
			<circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" />
			<path d="M12 7V12L14.5 14.5" stroke={color} strokeWidth="1.5" />
		</svg>
	);
};

export default ClockIcon;
